module.exports = __webpack_public_path__ + "img/idea_img4.3e35fdd5.png";